<template>
  <Loading v-if="isLoading"></Loading>
  <div v-else>
    <div class="teacher" :class="teacher_full_status ? 'teacher-full' : ''">
      <!-- 頭部組件 -->
      <Header
        v-show="!teacher_full_status"
        ref="HeaderRef"
        :agoraCamerasList="agoraCamerasList"
        :agoraMicrophoneList="agoraMicrophoneList"
        :agoraSpeakerList="agoraSpeakerList"
        @cameraChange="agoraCamerasChange"
        @microphoneChange="agoraMicrophoneChange"
        @speakerChange="agoraSpeakerChange"
        @screenShareChange="agoraScreen"
        @exitClassroom="agoraLeave"
        @clockIn="clockIn"
        @updateClassTime="updateClassTime"
        @checkFeedback="checkFeedback"
        @agoraScreenLeave="agoraScreenLeave"
        @agoraRecordStop="agoraRecordStop"
      />
      <div class="teacher-box">
        <div class="teacher-box-left">
          <!-- 畫板 -->
          <Sketchpad
            ref="SketchpadRef"
            @retrieveChats="retrieveChatsMessage"
            @newChatMessage="newChatMessage"
            @retrieveUserList="retrieveUserList"
            @clockIn="setClockIn"
            @clockOut="setClockOut"
            @student_drawing_permissions="changeStudentPermissions"
            @checkFeedback="onCheckFeedback"
            :speakerDeviceId="agoraSpeakerActive"
            @audioPlayStart="muteForAudio"
            @audioPlayStop="unmuteForAudio"
          />
        </div>
        <div class="teacher-box-right" v-show="!teacher_full_status">
          <!-- 老師畫面 -->
          <TeacherCamera
            :teacherName="teacherName"
            @cameraChange="agoraCameraEnabled"
            @mikeChange="agoraMicrophoneEnabled"
          />
          <!-- 學生畫面 -->
          <StudentCamera
            :studentName="studentName"
            :student_drawing_permissions="student_drawing_permissions"
            @speakerSoundChange="speakerSoundChange"
            @speakerSliderChange="speakerSliderChange"
            @shieldChange="onStudentShieldChange"
          />
          <!-- 聊聊 -->
          <Chat
            ref="retrieveChatsMessage"
            @retrieveChats="retrieveChatsSketchpad"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AgoraRTC from "agora-rtc-sdk-ng";
import Header from "./components/Header.vue";
import Sketchpad from "./components/Sketchpad.vue";
import TeacherCamera from "./components/TeacherCamera.vue";
import StudentCamera from "./components/StudentCamera.vue";
import Chat from "./components/Chat.vue";
import moment from "moment";
import Loading from "./components/Loading.vue";
import NotificationGuide from "@/static/components/NotificationGuide.vue";

export default {
  name: "Teacher",
  components: {
    Header,
    Sketchpad,
    TeacherCamera,
    StudentCamera,
    Chat,
    Loading,
  },
  data() {
    return {
      // 用戶信息
      userId: sessionStorage.getItem("agoraUid"),
      // agora配置
      // appId
      agoraAppId: process.env.VUE_APP_AGORA_APPID,
      // 頻道號
      agoraChannel: sessionStorage.getItem("agoraChannel"),
      // 根據頻道號生成的token
      agoraToken: sessionStorage.getItem("agoraToken"),
      // 加入 Uid = 13 + 用戶id
      agoraUid: Number("13" + sessionStorage.getItem("agoraUid")),
      // 視訊 Uid = 11 + 用戶id
      agoraCameraUid: Number("11" + sessionStorage.getItem("agoraUid")),
      // 熒幕分享 Uid = 12 + 用戶id
      agoraScreenUid: Number("12" + sessionStorage.getItem("agoraUid")),

      // agora實例
      // 加入頻道實例
      agoraClient: null,
      // 視訊實例
      agoraCameraClient: null,
      // 視頻本地實例
      localCameraClient: null,
      // 音頻本地實例
      localMicrophoneClient: null,
      // 熒幕分享實例
      localScreenTrack: null,
      // 熒幕分享本地實例
      agoraScreenClient: null,

      // 遠端音頻列表
      remoteUserAudioList: {},
      // 遠端視頻列表
      remoteUserVideoList: {},

      // 媒體設備列表
      // 視訊列表
      agoraCamerasList: [],
      agoraCamerasActive: "",
      // 麥克風列表
      agoraMicrophoneList: [],
      agoraMicrophoneActive: "",
      // 喇叭列表
      agoraSpeakerList: [],
      agoraSpeakerActive: "",

      // 上線驗證時間戳
      onlineTime: 0,
      // 上線驗證時長
      onlineSecond: 5,

      roomId: null,
      ClassKey: "eyJDbGFzc3Jvb21JZCI6MjIxNjUwMywiVXNlcklkIjoxNjc2ODl9",
      isLoading: true,
      userList: [],
      teacherName: "",
      studentName: "",
      student_drawing_permissions: null,
    };
  },
  computed: {
    ...mapGetters(["teacher_full_status"]),
    // ...mapGetters(['classRoomKey']),
  },
  created() {
    this.isLoading = false;
    this.getMedia();
    this.agoraInit();
  },
  mounted() {
    this.$watch(
      () => this.localCameraClient,
      () => {
        // 播放本地視頻
        this.localCameraClient.play("local-teacherCamera");
      }
    );
  },
  methods: {
    // 獲取媒體設備列表
    async getMedia() {
      // 獲取agora的視訊列表
      this.agoraCamerasList = await AgoraRTC.getCameras();
      this.agoraCamerasActive = this.agoraCamerasList?.[0]?.deviceId || "";
      // 獲取agora的麥克風列表
      this.agoraMicrophoneList = await AgoraRTC.getMicrophones();
      this.agoraMicrophoneActive =
        this.agoraMicrophoneList?.[0]?.deviceId || "";
      // 獲取agora的喇叭列表
      this.agoraSpeakerList = await AgoraRTC.getPlaybackDevices();
      this.agoraSpeakerActive = this.agoraSpeakerList?.[0]?.deviceId || "";
    },
    // 切換視訊設備
    agoraCamerasChange(val) {
      if (this.localCameraClient) {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        this.localCameraClient
          .setDevice(val)
          .then(() => {
            console.log("切換視訊成功 => ");
          })
          .catch((err) => {
            console.log("切換視訊報錯 => ", err);
          })
          .finally(() => {
            loading.close();
          });
      } else {
        if (process.env.VUE_APP_RUN_STATE != "local")
          alert("切換異常，請刷新後重試！");
      }
    },
    // 切換麥克風設備
    agoraMicrophoneChange(val) {
      if (this.localMicrophoneClient) {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        this.localMicrophoneClient
          .setDevice(val)
          .then(() => {
            console.log("切換麥克風成功 => ");
          })
          .catch((err) => {
            console.log("切換麥克風報錯 => ", err);
          })
          .finally(() => {
            loading.close();
          });
      } else {
        if (process.env.VUE_APP_RUN_STATE != "local")
          alert("切換異常，請刷新後重試！");
      }
    },
    // 切換喇叭設備
    agoraSpeakerChange(val) {
      for (let key in this.remoteUserAudioList) {
        this.remoteUserAudioList[key].audioTrack
          .setPlaybackDevice(val)
          .then(() => {
            console.log("切換喇叭成功 => ");
          })
          .catch((err) => {
            console.log("切換喇叭報錯 => ", err);
          });
      }
    },
    // 初始加入頻道 創建本地agora實例
    async agoraInit() {
      // 創建agora實例
      this.agoraClient = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });
      // 添加監聽事件 監聽用戶離開加入
      this.agoraClient.on("user-published", this.agoraUserPublished);
      this.agoraClient.on("user-unpublished", this.agoraUserUnpublished);
      this.agoraClient.on("user-joined", this.agoraUserJoined);
      // 創建一個時間戳 用於做上線驗證
      this.onlineTime = new Date().getTime();
      console.log("AgoraData", {
        agoraAppId: this.agoraAppId,
        agoraChannel: this.agoraChannel,
        agoraToken: this.agoraToken,
        agoraUid: this.agoraUid,
      });
      // 加入頻道
      await this.agoraClient.join(
        this.agoraAppId,
        this.agoraChannel,
        this.agoraToken,
        this.agoraUid
      );
      // 開啟視訊
      this.agoraCamera();
    },
    // 用戶監聽-監聽遠端用戶加入頻道 用於加入教室彈窗
    agoraUserJoined(user) {
      console.log("agoraUser", user);
      // 當前時間
      const nowTime = new Date().getTime();
      // 用當前時間和加入頻道時間對比 監聽用戶加入 彈出加入房間彈窗
      if (nowTime - this.onlineTime > this.onlineSecond * 1000) {
        this.$refs.HeaderRef.enteredHandle(user.uid);
      }
    },
    // 用戶監聽-訂閱遠端用戶發佈音視頻軌道
    async agoraUserPublished(user, mediaType) {
      console.log("agoraUserPublished", user);
      // 訂閱遠程用戶
      await this.agoraClient.subscribe(user, mediaType);
      // 根據uid區分並渲染畫面
      const type = user.uid.toString().slice(0, 2);
      // 根據uid獲取用戶id
      const userId = user.uid.toString().slice(2, user.uid.length);
      console.log("audioUid", userId, this.userId);
      // 音頻播放
      if (mediaType == "audio") {
        console.log("[Agora] 老師端收到遠端音頻", { uid: user.uid, type, userId, myUserId: this.userId, hasAudioTrack: !!user.audioTrack });
        // 播放音頻 除開自己的
        if (userId != this.userId) {
          // 加入至列表暫存
          this.remoteUserAudioList[user.uid] = user;
          user.audioTrack.play();
          console.log("[Agora] 老師端播放遠端音頻成功", user.uid);
        } else {
          console.log("[Agora] 老師端跳過自己的音頻", userId);
        }
        // 根據type設置用戶的播放按鈕狀態  21學生
        if (type == 21) {
          // 設置音頻播放按鈕狀態
          this.$store.commit("SET_STUDENTMIKESTATUS_TEACHER", true);
        }
      }
      // 視頻播放
      if (mediaType == "video") {
        // 加入至列表暫存
        this.remoteUserVideoList[user.uid] = user;
        // 根據type設置用戶的播放按鈕狀態  21學生
        if (type == 21) {
          // 播放視頻
          user.videoTrack.play("local-studentCamera");
          // 設置視頻播放按鈕狀態
          this.$store.commit("SET_STUDENTCAMERASTATUS_TEACHER", true);
        }
      }
    },
    // 用戶監聽-訂閱遠端用戶取消發佈音視頻軌道
    async agoraUserUnpublished(user, mediaType) {
      const type = user.uid.toString().slice(0, 2);
      // 判斷是不是學生的參數 是則關閉麥克風狀態
      if (type == 21) {
        if (mediaType == "audio") {
          this.$store.commit("SET_STUDENTMIKESTATUS_TEACHER", false);
        }
        if (mediaType == "video") {
          this.$store.commit("SET_STUDENTCAMERASTATUS_TEACHER", false);
        }
      }
      if (this.remoteUserAudioList[user.uid]) {
        delete this.remoteUserAudioList[user.uid];
      }
      if (this.remoteUserVideoList[user.uid]) {
        delete this.remoteUserVideoList[user.uid];
      }
    },
    // 視訊實例創建及推流
    async agoraCamera() {
      // 創建agora實例
      this.agoraCameraClient = AgoraRTC.createClient({
        mode: "rtc",
        codec: "vp8",
      });
      // 加入頻道
      await this.agoraCameraClient.join(
        this.agoraAppId,
        this.agoraChannel,
        this.agoraToken,
        this.agoraCameraUid
      );

      // 創建視頻流
      try {
        // Create video track
        this.localCameraClient = await AgoraRTC.createCameraVideoTrack();
        console.log("[Agora] 老師端攝像頭創建成功");
      } catch (cameraError) {
        // Handle camera error (e.g., show user warning)
        console.error("[Agora] 老師端攝像頭創建失敗", cameraError);
        this.$message.warning("無法開啟攝像頭，請檢查設備權限");
        this.localCameraClient = null; // Clear invalid reference
      }

      // 創建音頻流
      try {
        // Create audio track
        this.localMicrophoneClient = await AgoraRTC.createMicrophoneAudioTrack({
          AEC: true, // Enable Acoustic Echo Cancellation
          ANS: true, // Enable Automatic Noise Suppression
          AGC: true, // Enable Automatic Gain Control
        });
        console.log("[Agora] 老師端麥克風創建成功");
      } catch (micError) {
        // Handle microphone error
        console.error("[Agora] 老師端麥克風創建失敗", micError);
        this.$message.warning("無法開啟麥克風，請檢查設備權限");
        this.localMicrophoneClient = null;
      }

      // 加入訂閱推流
      const tracksToPublish = [];
      if (this.localCameraClient) tracksToPublish.push(this.localCameraClient);
      if (this.localMicrophoneClient)
        tracksToPublish.push(this.localMicrophoneClient);

      console.log("[Agora] 老師端準備發佈的軌道", tracksToPublish.map(t => t.trackMediaType));
      if (tracksToPublish.length > 0) {
        await this.agoraCameraClient.publish(tracksToPublish);
        console.log("[Agora] 老師端軌道發佈成功");
      }
      // // 播放本地視頻
      //   this.localCameraClient.play("local-teacherCamera");

      // 同时切换默认设备
      this.agoraCamerasChange(this.agoraCamerasActive);
      this.agoraMicrophoneChange(this.agoraMicrophoneActive);
      this.agoraSpeakerChange(this.agoraSpeakerActive);
    },
    // 關閉視訊頻道
    async agoraCameraLeave() {
      // 關閉視頻軌道
      if (this.localCameraClient) {
        this.localCameraClient.stop();
        this.localCameraClient.close();
        this.agoraCameraClient.unpublish(this.localCameraClient);
      }
      // 關閉音頻軌道
      if (this.localMicrophoneClient) {
        this.localMicrophoneClient.stop();
        this.localMicrophoneClient.close();
        this.agoraCameraClient.unpublish(this.localMicrophoneClient);
      }
      // 斷開客戶鏈接
      if (this.agoraClient) {
        await this.agoraClient.leave();
      }
    },
    // 視訊狀態開關
    async agoraCameraEnabled(val) {
      console.log("視訊狀態開關", val);
      if (this.localCameraClient) {
        await this.localCameraClient.setEnabled(val);
      }
    },
    // 麥克風狀態開關
    async agoraMicrophoneEnabled(val) {
      console.log("麥克風狀態開關", val);
      if (this.localMicrophoneClient) {
        await this.localMicrophoneClient.setEnabled(val);
      }
    },
    // 播放 MP3 時靜音麥克風，避免揚聲器被採集產生回音
    async muteForAudio() {
      if (this.localMicrophoneClient) {
        await this.localMicrophoneClient.setEnabled(false);
      }
    },
    // 暫停/停止 MP3 後恢復麥克風
    async unmuteForAudio() {
      if (this.localMicrophoneClient) {
        await this.localMicrophoneClient.setEnabled(true);
      }
    },
    // 調整揚聲器音量
    agoraSetVolume(num) {
      for (let key in this.remoteUserAudioList) {
        let type = key.toString().slice(0, 2);
        if (["21"].includes(type)) {
          this.remoteUserAudioList[key].audioTrack.setVolume(num);
        }
      }
    },
    // 學生端聲音開關
    speakerSoundChange(flag) {
      if (flag) {
        this.agoraSetVolume(50);
      } else {
        this.agoraSetVolume(0);
      }
    },
    // 學生端聲音調整
    speakerSliderChange(val) {
      this.agoraSetVolume(val);
    },
    // 熒幕分享實例創建及推流
    async agoraScreen() {
      // 創建視頻流
      const [screenTrack] = await Promise.all([
        AgoraRTC.createScreenVideoTrack({ encoderConfig: "1080p_1" }, "auto"),
      ]);
      const screenTrackAll = screenTrack;
      if (screenTrack && screenTrack.length > 1) {
        this.localScreenTrack = screenTrack[0];
      } else {
        this.localScreenTrack = screenTrack;
      }

      if (this.localScreenTrack) {
        this.$refs.HeaderRef.screenShareShowClose();
      }

      this.$refs.HeaderRef.setRecordState(true);

      // 創建agora實例
      this.agoraScreenClient = AgoraRTC.createClient({
        mode: "rtc",
        codec: "vp8",
      });
      // 加入頻道
      await this.agoraScreenClient.join(
        this.agoraAppId,
        this.agoraChannel,
        this.agoraToken,
        this.agoraScreenUid
      );
      // 加入訂閱推流
      await this.agoraScreenClient.publish(screenTrackAll);

      let that = this;
      // 監聽熒幕分享是否終止
      this.localScreenTrack.on("track-ended", async () => {
        try {
          this.notificatonGuideClass(`The recording is stopped forcefully! Please wait a few seconds to start the recording again.`)
          setTimeout(async () => {
            // 熒幕分享停止推流
            await that.agoraScreenLeave();
          }, 2000); 
        } catch (err) {
          console.error("Screen track ended error:", err);
        } finally {
          // 重新打卡分享彈窗
          that.$refs.HeaderRef.screenShareOpen();
          // this.$refs.HeaderRef.isRecordingTransitioning = false;
        }
      });

      // 開啟雲端錄製
      this.agoraRecordStart();
    },
    // 關閉熒幕分享頻道
    async agoraScreenLeave() {
      // 關閉熒幕分享軌道
      if (this.localScreenTrack) {
        this.localScreenTrack.stop();
        this.localScreenTrack.close();
      }
      // 斷開視頻分享連接
      if (this.agoraScreenClient) {
        await this.agoraScreenClient.leave();
      }
      // 停止雲端錄製
      this.agoraRecordStop();
    },
    // 熒幕分享-停止雲端錄製
    async agoraRecordStop() {
      if (this.$refs.HeaderRef.isRecordingTransitioning) return;
      this.$refs.HeaderRef.isRecordingTransitioning = true;
      
      try {
        this.notificatonGuideClass(`The recording is gonna stop, please wait...`)
        this.$refs.HeaderRef.setRecordState(false);
        await this.$store.dispatch("aograRecordStop");
      } catch (err) {
        console.error("Stop error:", err);
      } finally {
        // ✅ Allow polling again after short buffer
        setTimeout(() => {
          this.$refs.HeaderRef.isRecordingTransitioning = false;
          this.notificatonGuideClass(`The recording is stopped successfully!`)
        }, 1000); // or a bit more if needed
      }
    },
    // 熒幕分享-開啟雲端錄製
    async agoraRecordStart() {
      if (this.$refs.HeaderRef.isRecordingTransitioning) return;
      this.$refs.HeaderRef.isRecordingTransitioning = true;

      try {
        this.notificatonGuideClass(`The recording is gonna start, please wait...`)
        this.$refs.HeaderRef.setRecordState(true);
        await this.$store.dispatch("aograRecordStart");

        // ✅ Start successful, sid/resourceId should now be set
      } catch (err) {
        console.error("Start error:", err);
      } finally {
        // ✅ Allow polling again after short buffer
        setTimeout(() => {
          this.$refs.HeaderRef.isRecordingTransitioning = false;
          this.notificatonGuideClass(`The recording is started successfully!`)
        }, 1000); // or a bit more if needed
      }
    },
    notificatonGuideClass(message) {
      this.$toast(
          {
            component: NotificationGuide,
            props: {
              message: message,
            },
          },
          {
            position: "top-right",
            timeout: 3000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: true,
            closeButton: "button",
            icon: true,
            rtl: false,
          }
        );
    },
    // 離開頻道 停止所有本地播放
    async agoraLeave() {
      this.remoteUserAudioList = {};
      this.remoteUserVideoList = {};
      await this.agoraCameraLeave();
      await this.agoraScreenLeave();

      console.log("userexit");
      sessionStorage.clear();
      this.$router.push("/?key=");
    },
    beforeJoinClass() {
      this.$store.dispatch("joinNewClassHitutor", {
        ClassKey: this.ClassKey,
      });
      this.$store.commit("setClassRoomKey", this.ClassKey);
    },
    retrieveChatsSketchpad(msg) {
      if (msg) {
        this.$refs.SketchpadRef.pushChatMessage(msg);
      } else {
        this.$refs.SketchpadRef.retrieveChats();
      }
    },
    retrieveChatsMessage() {
      this.$refs.retrieveChatsMessage.retrieveChatsMessage();
    },
    newChatMessage(msg) {
      this.$refs.retrieveChatsMessage.addMessage(msg);
    },
    retrieveUserList(data) {
      this.userList = data;
      for (let i = 0; i < data.length; i++) {
        if (data[i].userType == 1) {
          this.teacherName = data[i].user;
        } else if (data[i].userType == 0) {
          this.studentName = data[i].user;
        }
      }
      const checkTeacherExist = data.some((i) => i.userType == 1);
      if (!checkTeacherExist) this.teacherName = "";
      const checkStudentExist = data.some((i) => i.userType == 0);
      if (!checkStudentExist) this.studentName = "";
    },
    changeStudentPermissions(data) {
      console.log(data);
      this.student_drawing_permissions = data;
    },
    onStudentShieldChange() {
      this.$refs.SketchpadRef.shieldChange();
    },
    setTimerRun() {
      this.$refs.HeaderRef.timerRun();
    },
    timerRunCount() {
      this.$refs.SketchpadRef.setTimerRun();
    },
    clockIn(val) {
      this.$refs.SketchpadRef.setClockIn(val);
    },
    updateClassTime(val) {
      this.$refs.SketchpadRef.updateClassTime(val);
    },
    setClockIn(val) {
      this.$refs.HeaderRef.setClockIn(val);
    },
    setClockOut() {
      this.$refs.HeaderRef.setClockOut();
    },
    checkFeedback() {
      this.$refs.SketchpadRef.checkFeedback();
    },
    onCheckFeedback() {
      this.$refs.HeaderRef.checkFeedback();
    },
  },
  beforeDestroy() {
    // 頁面銷毀時 離開agora
    this.agoraCameraLeave();
    this.agoraScreenLeave();
  },
};
</script>

<style lang="scss" scoped>
.teacher {
  width: 100%;
  height: 100%;
  overflow: hidden;

  .teacher-box {
    padding: 0 20px 10px;
    height: calc(100% - 60px);
    display: flex;

    .teacher-box-left {
      padding-right: 16px;
      flex: 1;
      min-width: 0;
    }

    .teacher-box-right {
      width: 468px;
      flex-shrink: 0;
      overflow-y: auto;
    }
  }
}

.teacher-full {
  .teacher-box {
    padding: 0 150px;
    height: 100%;

    .teacher-box-left {
      padding-right: 0;
    }
  }
}
</style>
